import React, {useState} from 'react';
import {connect} from 'react-redux'
import {Link} from "react-router-dom";
import {postPasswordResetLink} from './api';
import './styles/LoginPage.css';

function ForgotPasswordPage(props) {
    const [formData, setFormData] = useState({'email': ''});
    const [alertBs, setAlertBs] = useState(null);

    function handleInputChange(event) {
        const target = event.target;
        const _formData = {...formData};
        _formData[target.name] = target.value;
        setFormData(_formData);
    }

    function handleLoginClick(e) {
        e.preventDefault();
        setAlertBs(<div className="alert alert-info" role="alert">Working...</div>);
        postPasswordResetLink(formData)
            .then((data) => {
                setAlertBs(<div className="alert alert-success" role="alert">{data['message']}</div>);
            })
            .catch((error) => {
                setAlertBs(<div className="alert alert-danger" role="alert">{error.toString()}</div>);
            })
    }

    return (
        <div className="background-image">
            <div className="container login">

                <div className="row">
                    <div className="col-md-8 col-md-offset-2">
                        <div className="javascript-required alert alert-warning lead text-center"
                             style={{display: "none"}}>
                            <p>This website requires a modern browser with javascript enabled.</p>
                            <p>Please disable any javascript blockers and/or use a different browser.</p>
                        </div>

                        <div className="panel panel-default login-area">
                            <div className="panel-heading">Forgot password</div>
                            <div className="panel-body">
                                <form className="form-horizontal">
                                    <div className="form-group">
                                        <label htmlFor="email" className="col-md-4 control-label">E-Mail Address</label>

                                        <div className="col-md-6">
                                            <input id="email" type="email" className="form-control" name="email"
                                                   value={formData.email} onChange={handleInputChange} required=""
                                                   autoFocus=""/>

                                        </div>
                                    </div>

                                    <div className="form-group">
                                        <div className="col-md-8 col-md-offset-4">
                                            <button className="btn btn-primary"
                                                    onClick={handleLoginClick}>
                                                Send Password Reset Link
                                            </button>

                                            <a className="btn btn-link">
                                                <Link to="/login">Back to Login</Link>
                                            </a>
                                        </div>
                                    </div>
                                </form>
                                {alertBs}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default connect(
    null,
    null
)(ForgotPasswordPage)
